import {
  FETCH_COMPANIES,
  FETCH_DATA_COMPANIES,
} from '../../constants/ActionTypes'

export const fetchCompanies = () => {
  return dispatch => {
    fetch(
      'https://appvendedores.comprasdavivienda.cr/resources/ws/getCompanies.php',
    )
      .then(response => {
        return response.json()
      })
      .then(response => {
        dispatch({
          type: FETCH_COMPANIES,
          payload: response.result,
        })
      })
  }
}

export const fetchDataCompanies = ({idCompany, dateFrom, dateTo}) => {
  return dispatch => {
    fetch(
      `https://appvendedores.comprasdavivienda.cr/resources/ws/getUsedPointsByCompany.php/getUsedPointsByCompany?companyId=${idCompany}&dateFrom=${dateFrom}&dateTo=${dateTo}`,
    )
      .then(response => {
        return response.json()
      })
      .then(response => {
        console.log('data ', response)
        dispatch({
          type: FETCH_DATA_COMPANIES,
          payload: response,
        })
      })
  }
}



// WEBPACK FOOTER //
// ./src/appRedux/actions/Companies.js